<app>
    <nav-bar
            user="{opts.user}"
    ></nav-bar>

    <!--  hero banner   -->
    <section class="demo-hero-5" data-pages="parallax"
             data-pages-bg-image="/static/eshop/assets/images/aeroviewer-home-2-min.jpg">
        <div class="container-xs-height full-height hero-gradient">
            <div class="col-xs-height col-middle text-center">
                <h1 class="text-white inner bold">Aerial Videos & Photos</h1>
            </div>
        </div>
    </section>
    <!--  End of hero banner   -->

    <!--  Content Area  -->
    <section class="p-b-40 pt-5">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <h3 class="aeroviewer-element-container-heading">EXPLORE AEROVIEWER MEDIA BANK</h3>
                    <p class="aeroviewer-element-container-sub">Find hundreds of hours of aerial Video and hundreds of
                        thousands of
                        aerial photos.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-photo-select" href="/photo-select">
                        <div class="aeroviewer-element-image">
                            <img src="/static/eshop/assets/banners/photo-banner-min.jpg" class="img-fluid rounded w-100"
                                 alt="photo-banner">
                            <div class="element-overlay">
                                <div class="overlay-text-center text-center">
                                    <i class="fa fa-image fa-3x text-white element-icon"></i>
                                </div>

                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Thousand aerial photos</p>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-footage-select" href="/footage-select">
                        <div class="aeroviewer-element-image">
                            <img src="/static/eshop/assets/banners/video-banner-min.jpg" class="img-fluid rounded w-100"
                                 alt="video-banner">
                            <div class="element-overlay">
                                <div class="overlay-text-center text-center">
                                    <i class="fa fa-video-camera fa-3x text-white element-icon"></i>
                                </div>

                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Hundreds hours of aerial video</p>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-collection-select" href="/collection-select">
                        <div class="aeroviewer-element-image">
                            <img src="/static/eshop/assets/banners/collection-banner-min.jpg"
                                 class="img-fluid rounded w-100"
                                 alt="collection-banner">
                            <div class="element-overlay">
                                <div class="overlay-text-center text-center">
                                    <i class="fa fa-folder-open fa-3x text-white element-icon"></i>
                                </div>
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Over 6000 hand picked collections</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
    <!--  End of content Area   -->

    <!--  DigiShare Area  -->
    <section class="p-b-40 pt-5">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h3 class="aeroviewer-element-container-heading mb-0">Learn about DigiShare™ service</h3>
                    <p class="aeroviewer-element-container-sub mb-1">Customize and deploy visual content</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-digishare-choose" href="/digishare">
                        <div class="aeroviewer-element-image">
                            <img src="/static/eshop/assets/images/avr-record.png" class="img-fluid rounded w-100"
                                 alt="digishare-record">
                            <div class="element-overlay">
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Choose</p>
                            <p class="aeroviewer-element-sub">Select (capture) the video segments or choose the photos
                                you
                                like most. To find the content
                                type
                                the name of the area or drag and drop the heli-Pin on the Map.</p>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-digishare-compose" href="/digishare">
                        <div class="aeroviewer-element-image">
                            <img src="/static/eshop/assets/images/avr-compose-2.png" class="img-fluid rounded w-100"
                                 alt="digishare-compose">
                            <div class="element-overlay">
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Compose</p>
                            <p class="aeroviewer-element-sub">Arrange in the preferred order the video segments you like
                                to
                                use in your video-clip or the
                                photos to use in your slideshow. You have created your tailor made video /
                                slideshow.</p>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-digishare-deploy" href="/digishare">
                        <div class="aeroviewer-element-image">
                            <img src="/static/eshop/assets/images/avr-deploy.png" class="img-fluid rounded w-100"
                                 alt="digishare-deploy">
                            <div class="element-overlay">
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Deploy</p>
                            <p class="aeroviewer-element-sub">The created visual content is immediately available and
                                ready
                                to be streamed from our CDN to
                                the
                                preferred location or page on your site. The widget is a click away of your site.</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
    <!--  End of DigiShare Area  -->

    <!-- Discover Photos area -->
    <section class="p-b-40 pt-5">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h3 class="aeroviewer-element-container-heading mb-0">Discover exclusive Aerial Content from
                        Mediterranean coastline</h3>
                    <p class="aeroviewer-element-container-sub">with thousands of aerial photos</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-xl-6 aeroviewer-col-element">
                    <a id="home-milos-photo" href="/photo/detail/greece-milos/1136990470598035425">
                        <div class="aeroviewer-element-image">
                            <img src="https://d2wzo7cpkz5upz.cloudfront.net/photos2/Milos/SSS/WWIP5627.jpg"
                                 class="img-fluid rounded w-100"
                                 alt="Greece Milos">
                            <div class="element-overlay">
                                <div class="overlay-text-top text-right">
                                    <span class="text-white">greece#milos</span>
                                </div>
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Greece Milos</p>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-6 aeroviewer-col-element">
                    <a id="home-oludeniz-photo"
                       href="/photo/detail/turkey-mugla-fethiye-oludeniz-oludeniz/1064486922312746971">
                        <div class="aeroviewer-element-image">
                            <img src="https://d2wzo7cpkz5upz.cloudfront.net/photos2/20150615_10-01_TR_Kalka-TR_Fethiye/SSS/10-01_SIDE_IMG_7402.jpg"
                                 class="img-fluid rounded w-100"
                                 alt="Turkey mugla fethiye oludeniz">
                            <div class="element-overlay">
                                <div class="overlay-text-top text-right">
                                    <span class="text-white">turkey#mugla#oludeniz</span>
                                </div>
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Turkey Mugla Fethiye Oludeniz</p>
                        </div>
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-valencia-photo"
                       href="/photo/detail/spain-comunidad-valenciana-valencia-norte-beach-of-gandia/1078902337147242446">
                        <div class="aeroviewer-element-image">
                            <img src="https://d2wzo7cpkz5upz.cloudfront.net/photos2/20140907_0672_ES_Benicarlo-ES_Gandia/SSS/0672_FRONT_IMG_6626.jpg"
                                 class="img-fluid rounded w-100"
                                 alt="Spain Valencia">
                            <div class="element-overlay">
                                <div class="overlay-text-top text-right">
                                    <span class="text-white">spain#valenciana#valencia</span>
                                </div>
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Spain Comunidad Valenciana Valencia</p>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-smeralda-photo"
                       href="/photo/detail/hotel-pitrizza-a-luxury-collection-hotel-costa-smeralda/1078902378452748034">
                        <div class="aeroviewer-element-image">
                            <img src="https://d2wzo7cpkz5upz.cloudfront.net/photos2/20140827_0656_IT_Sardegna_SantaTeresaGallura-IT_Sardegna_GolfoPevero/SSS/0656_TELE_TIP_5690.JPG"
                                 class="img-fluid rounded w-100"
                                 alt="Italy Sardegna">
                            <div class="element-overlay">
                                <div class="overlay-text-top text-right">
                                    <span class="text-white">italy#sardegna</span>
                                </div>
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Hotel pitrizza, costa smeralda</p>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-marseille-photo"
                       href="/photo/detail/france-provence-alpes-côte-d-azur-bouches-du-rhône-marseille-marseille/1078901878114223695">
                        <div class="aeroviewer-element-image">
                            <img src="https://d2wzo7cpkz5upz.cloudfront.net/photos2/20141004_0692_FR_Marseille-FR_Niolon/SSS/0692_TELE_TIP_1951.JPG"
                                 class="img-fluid rounded w-100"
                                 alt="France, ">
                            <div class="element-overlay">
                                <div class="overlay-text-top text-right">
                                    <span class="text-white">france#marseille</span>
                                </div>
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">France Bouches du rhône Marseille</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
    <!-- End of Photos area -->

    <!-- Discover collections area -->
    <section class="p-b-40 pt-5">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h3 class="aeroviewer-element-container-heading mb-0">Explore our hand-picked media collections</h3>
                    <p class="aeroviewer-element-container-sub">in amazing bundle prices</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-xl-6 aeroviewer-col-element">
                    <a id="home-navagio-video" href="/collection/detail/greece-zakynthos-navagio-wreck-bay/53615">
                        <div class="aeroviewer-element-image">
                            <img src="https://d2wzo7cpkz5upz.cloudfront.net/photos2/Zakinthos_1/SSS/_WIP0045 (1) .jpg"
                                 class="img-fluid rounded w-100"
                                 alt="Greece Zakynthos Navagio">
                            <div class="element-overlay">
                                <div class="overlay-text-top text-right">
                                    <span class="text-white"><b>
                                        00:00:09 <i class="fa fa-video-camera"></i>
                                    </b>
                                    </span><br>
                                    <span class="text-white">
                                        <b>3 <i class="fa fa-image"></i></b>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Greece Zakynthos Navagio</p>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-6 aeroviewer-col-element">
                    <a id="home-portofino-video" href="/collection/detail/italy-linguria-genova-portofino/57705">
                        <div class="aeroviewer-element-image">
                            <img src="/static/web/assets/collections/portofino-57705-collection.jpg"
                                 class="img-fluid rounded w-100"
                                 alt="Italy, Linguria, Genova, Portofino">
                            <div class="element-overlay">
                                <div class="overlay-text-top text-right">
                                    <span class="text-white"><b>
                                        00:04:12 <i class="fa fa-video-camera"></i>
                                    </b>
                                    </span><br>
                                    <span class="text-white">
                                        <b>270 <i class="fa fa-image"></i></b>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Italy, Linguria, Genova, Portofino</p>
                        </div>
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-calau-video" href="/collection/detail/spain-cataluna-girona-calau-beach/50532">
                        <div class="aeroviewer-element-image">
                            <img src="https://d2wzo7cpkz5upz.cloudfront.net/photos2/20140904_0669-02_ES_Empuriabrava-ES_ElMasnou/TLS/0669-02_SIDE_IMG_5669.jpg"
                                 class="img-fluid rounded w-100"
                                 alt="Spain, Cataluña, Girona, Calau Beach">
                            <div class="element-overlay">
                                <div class="overlay-text-top text-right">
                                     <span class="text-white"><b>
                                        00:00:15 <i class="fa fa-video-camera"></i>
                                    </b>
                                    </span><br>
                                    <span class="text-white">
                                        <b>4 <i class="fa fa-image"></i></b>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Spain, Cataluña, Girona, Calau Beach</p>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-kemer-video" href="/collection/detail/turkey-antalya-kemer-kemer-east-bay/50125">
                        <div class="aeroviewer-element-image">
                            <img src="https://d2wzo7cpkz5upz.cloudfront.net/photos2/20150614_08-01_TR_Karadayi-TR_Kemer/SSS/08-01_WIDE_W2IP9539.jpg"
                                 class="img-fluid rounded w-100"
                                 alt="Turkey, Antalya, Kemer, Kemer East Bay">
                            <div class="element-overlay">
                                <div class="overlay-text-top text-right">
                                    <span class="text-white"><b>
                                        00:01:07 <i class="fa fa-video-camera"></i>
                                    </b>
                                    </span><br>
                                    <span class="text-white">
                                        <b>63 <i class="fa fa-image"></i></b>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">Turkey, Antalya, Kemer, Kemer East Bay</p>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-calvi-video" href="/collection/detail/france-corsica-calvi/58424">
                        <div class="aeroviewer-element-image">
                            <img src="https://d2wzo7cpkz5upz.cloudfront.net/photos2/20140828_0659_FR_Corsica_Piana-FR_Corsica_StMaria/SSS/0659_SIDE_IMG_0482.JPG"
                                 class="img-fluid rounded w-100"
                                 alt="France, corsica, Calvi">
                            <div class="element-overlay">
                                <div class="overlay-text-center text-center">
                                     <span class="text-white"><b>
                                        00:01:48 <i class="fa fa-video-camera"></i>
                                    </b>
                                    </span><br>
                                    <span class="text-white">
                                        <b>12 <i class="fa fa-image"></i></b>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="aeroviewer-element-text">
                            <p class="h6 aeroviewer-element-title">France, corsica, Calvi</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
    <!-- End of collections area -->

    <!-- Categories -->
    <section class="p-b-40 pt-5">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <h3 class="aeroviewer-element-container-heading">BOOST YOUR BUSINESS WITH AEROVIEWER</h3>
                    <p class="aeroviewer-element-container-sub">If you operate a Creative office, a Digital
                        communication company, a Travel agency, a Real-Estate agency, a Hotel or if you are a Tour
                        operator, an Airliner, a Publisher, a Video producer, a TV- channel, a Tourism authority, a
                        Tourism service provider, a Bank, an Insurance company, an Airport or any other Businesses we
                        have something very interesting for you.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-category-tourism" href="/tourism">
                        <div class="aeroviewer-element-image container-16by9">
                            <img src="/static/web/assets/images/tourism-banner-min.png"
                                 class="img-fluid rounded w-100 w-100"
                                 alt="aeroviewer-tourism">
                            <div class="element-overlay-reverse img-fluid rounded w-100">
                                <div class="overlay-text-center text-center">
                                    <p class="h4 text-white bold">Tourism</p>
                                </div>
                                <div class="overlay-text-center">
                                    <div class="aeroviewer-loader w-100"><span></span></div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-category-digital" href="/digital-communication">
                        <div class="aeroviewer-element-image container-16by9">
                            <img src="/static/web/assets/images/digital-banner-min.png" class="img-fluid rounded w-100"
                                 alt="aeroviewer-creative-offices">
                            <div class="element-overlay-reverse img-fluid rounded">
                                <div class="overlay-text-center text-center">
                                    <p class="h4 text-white bold">Creative Offices</p>
                                </div>
                                <div class="overlay-text-center">
                                    <div class="aeroviewer-loader w-100"><span></span></div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-category-social" href="/social-media">
                        <div class="aeroviewer-element-image container-16by9">
                            <img src="/static/web/assets/images/social-banner-min.png" class="img-fluid rounded w-100"
                                 alt="aeroviewer-social-media">
                            <div class="element-overlay-reverse img-fluid rounded">
                                <div class="overlay-text-center text-center">
                                    <p class="h4 text-white bold">Social Media</p>
                                </div>
                                <div class="overlay-text-center">
                                    <div class="aeroviewer-loader w-100"><span></span></div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-category-estate" href="/real-estate">
                        <div class="aeroviewer-element-image container-16by9">
                            <img src="/static/web/assets/images/real-estate-banner-min.png"
                                 class="img-fluid rounded w-100"
                                 alt="aeroviewer-real-estate">
                            <div class="element-overlay-reverse img-fluid rounded">
                                <div class="overlay-text-center text-center">
                                    <p class="h4 text-white bold">Real Estate</p>
                                </div>
                                <div class="overlay-text-center">
                                    <div class="aeroviewer-loader w-100"><span></span></div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-category-media" href="/on-line-media">
                        <div class="aeroviewer-element-image container-16by9">
                            <img src="/static/web/assets/images/blogs-banner-min.png" class="img-fluid rounded w-100"
                                 alt="aeroviewer-news-blogs">
                            <div class="element-overlay-reverse img-fluid rounded">
                                <div class="overlay-text-center text-center">
                                    <p class="h4 text-white bold">News Blogs</p>
                                </div>
                                <div class="overlay-text-center">
                                    <div class="aeroviewer-loader w-100"><span></span></div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 col-xl-4 aeroviewer-col-element">
                    <a id="home-category-engineering" href="/engineering">
                        <div class="aeroviewer-element-image container-16by9">
                            <img src="/static/web/assets/images/architect-banner-min.png"
                                 class="img-fluid rounded w-100"
                                 alt="aeroviewer-civil-engineer">
                            <div class="element-overlay-reverse img-fluid rounded">
                                <div class="overlay-text-center text-center">
                                    <p class="h4 text-white bold">Civil Engineering</p>
                                </div>
                                <div class="overlay-text-center">
                                    <div class="aeroviewer-loader w-100"><span></span></div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
    <!-- End categories -->


    <section class="p-b-50">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h3 class="aeroviewer-element-container-heading mb-0">Join the AeroViewer Community</h3>
                    <p class="aeroviewer-element-container-sub">explore world's first aerial marketplace</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-12">
                    <blockquote class="blockquote">
                        <p class="mb-0">We were surprised when we discovered that the only source to find aerial photos
                            and videos for all of the 3.000 beaches
                            we are presenting in our site, was the AEROVIEWER platform</p>
                        <br>
                        <footer class="blockquote-footer">Panagiotis Paschalakis, <cite title="Source Title">Founder
                            Safewatersports.com</cite></footer>
                    </blockquote>
                </div>
                <div class="col-md-4 col-sm-12">
                    <blockquote class="blockquote">
                        <p class="mb-0">I am very satisfied with the AEROVIEWER platform and I am using its high quality
                            aerial
                            photos and videos for my Projects. I love the idea "Visual Content Tailored by You ". We
                            have
                            included to our proposal for the Delos Museum a unique video using content and tools found
                            on AEROVIEWER.</p>
                        <br>
                        <footer class="blockquote-footer">Jean-Pierre HEIM & associates, <cite title="Source Title">Founder
                            Architects/Designers</cite></footer>
                    </blockquote>
                </div>
                <div class="col-md-4 col-sm-12">
                    <blockquote class="blockquote">
                        <p class="mb-0">We thought it would be impossible but, we found in AEROVIEWER amazing photos and
                            videos of a remote area in the not so famous island of Karpathos in Greece. We were happy to
                            hear that we could use them for a very affordable price!</p>
                        <br>
                        <footer class="blockquote-footer">Maria Papafigou, <cite title="Source Title">OOAK Architects
                            AB</cite></footer>
                    </blockquote>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-12 no-padding text-center">
                    <a id="home-create-account" class="btn aero-btn-primary btn-lg w-50 fa-2x"
                       style="padding: 1.5rem 1rem;"
                       href="/signup">Create Free Account</a>
                </div>
            </div>
        </div>
    </section>


    <avr-footer></avr-footer>

    <script>

        import '../../components/nav-bar/nav-bar.tag.html';
        import '../../components/avr-footer/avr-footer.tag.html';

        const app = this;
    </script>
</app>


// WEBPACK FOOTER //
// avr_eshop/frontend/apps/home/app.tag.html